module.exports = __webpack_public_path__ + "static/media/Cyroth-EI.696dcd62.png";